//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const picker = ref(null)

    return {
      picker,
    }
  },
}
